import * as React from "react";
import { useState, useEffect } from "react";
import { Avatar, Grid, Box, TextField, Typography, Container } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
// import Link from "@mui/material/Link";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useSelector, useDispatch } from "react-redux";
import { userActions } from '../../actions/user.actions';

import { resolveComponentProps } from "@mui/base";
import {googleLogout, useGoogleLogin } from '@react-oauth/google';
import axiosInstance from '../../interceptor/interceptor';
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";

const google_client_id = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function Copyright(props) {
  return (
    <Typography
      style={{position:'absolute'}}
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      JsonWorld
      {" © "}
        
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

export function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.userReducer.isLoggedIn);
  const [ user, setUser ] = useState([]);
  const [ profile, setProfile ] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ defaultView, setDefaultView ] = useState(true);
  const [ showEmailRegister, setShowEmailRegister ] = useState(false);
  const [ showEmailLogin, setShowEmailLogin ] = useState(false);
  const [ showForgotPassword, setShowForgotPassword ] = useState(false);
  //const [isLoggedIn, setLoginStatus] = useSelector((state) => state.userReducer.isLoggedIn) ? true : null;
  const [inputField, setInputField] = React.useState({
    full_name: "",
    email: "",
    password: "",
  });

  const inputsHandler = (e) => {
    setInputField({ ...inputField, [e.target.name]: e.target.value });
  }

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.error('Login Failed:', error)
  });

  const showDefaultView = () =>{
    setDefaultView(true);
    setShowEmailRegister(false);
    setShowEmailLogin(false);
    setShowForgotPassword(false);
  }

  const emailRegister = () =>{
    setDefaultView(false);
    setShowEmailRegister(true);
    setShowEmailLogin(false);
    setShowForgotPassword(false);
  }

  const emailLogin = () =>{
    setDefaultView(false);
    setShowEmailRegister(false);
    setShowEmailLogin(true);
    setShowForgotPassword(false);
  }

  const forgotPassword = () =>{
    setDefaultView(false);
    setShowEmailRegister(false);
    setShowEmailLogin(false);
    setShowForgotPassword(true);
  }


   useEffect(
    () => {
        if (user && user.access_token) {
            axios
                .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                    headers: {
                        Authorization: `Bearer ${user.access_token}`,
                        Accept: 'application/json'
                    }
                })
                .then((res) => {
                    const GoogleObject = {
                      "name":res.data.name, 
                      "email": res.data.email, 
                      "google_id": res.data.id
                    }
                    dispatch(userActions.loginRequest(GoogleObject));
                })
                .catch((err) => console.error(err));
        }
    },
    [ user ]
  );

  const handleRegisterSubmit = async () => {
    try {
      // Validate User Input
      if (inputField.full_name === "") {
        toast.info("Enter your name", { type: "error" });
        return false;
      }
      if (inputField.email === "") {
        toast.info("Enter your email", { type: "error" });
        return false;
      }
      const regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!regexEmail.test(inputField.email)) {
        toast.info("Entered email is invalid", { type: "error" });
        return false;
    }
      if (inputField.password === "" || inputField.password.length < 6) {
        toast.info("Enter password with atleast 6 characters", { type: "error" });
        return false;
      }
      setIsLoading(true);
      const res = await axiosInstance.post(
        `api?method=email_register`,
        {full_name:inputField.full_name, email:inputField.email,password: inputField.password}
      );
      setIsLoading(false);
      toast(res.data.message, { type: "success" });
      setInputField({ ...inputField, full_name:"", email:"", password: "" });
      showDefaultView();
    } catch (e) {
      setIsLoading(false);
      toast.info(`Error: ${e.response?.data?.message || 'Something went wrong.'}`, { type: "error" });
    }
  };

  const handleLoginSubmit = async () => {
    try {
      // Validate User Input
      if (inputField.email === "") {
        toast.info("Enter your email", { type: "error" });
        return false;
      }
      const regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!regexEmail.test(inputField.email)) {
        toast.info("Entered email is invalid", { type: "error" });
        return false;
    }
      if (inputField.password === "" || inputField.password.length < 6) {
        toast.info("Enter password with atleast 6 characters", { type: "error" });
        return false;
      }
      setIsLoading(true);
      const res = await axiosInstance.post(
        `api?method=email_login`,
        {email:inputField.email, password: inputField.password}
      );
      setIsLoading(false);
      if(res.data.status== 200) {
        toast(res.data.message, { type: "success" });
        setInputField({ ...inputField, email:"", password: "" });
        dispatch(userActions.loginUser(res.data.result));  
      } else {
        toast.info(`Error: ${res.data.message || "something went wrong!"}`, { type: "error" });
      }
    } catch (e) {
      console.error(JSON.stringify(e), "error asdfaf");
      
      setIsLoading(false);
      toast.info(`Error: ${e?.response?.data?.message || "something went wrong!"}`, { type: "error" });
    }
  }

  const handleForgotPassword = async() => {
    try {
       // Validate User Input
       if (inputField.email === "") {
        toast.info("Enter your email", { type: "error" });
        return false;
      }
      const regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!regexEmail.test(inputField.email)) {
        toast.info("Entered email is invalid", { type: "error" });
        return false;
      }
      setIsLoading(true);
      const res = await axiosInstance.post(
        `api?method=request_reset_password`,
        {email:inputField.email}
      );
      setIsLoading(false);
      if(res.data.status== 200) {
        toast(res.data.message, { type: "success" });
        setInputField({ ...inputField, email:""});
      } else {
        toast.info(`Error: ${res?.data?.message || "something went wrong!"}`, { type: "error" });
      }
    } catch(e) {
      setIsLoading(false);
      toast.info(`Error: ${e?.response?.data?.message || "something went wrong!"}`, { type: "error" });
    }
  }

    // log out function to log the user out of google and set the profile array to null
    // const logOut = () => {
    //     googleLogout();
    //     setProfile(null);
    // };

  useEffect(()=>{
    if(isLoggedIn == true){
      // 👇 Redirects to about page, note the `replace: true`
      navigate('/web', { replace: true });
      // return;
    }
  },[isLoggedIn]);

  return (
    <ThemeProvider theme={theme}>
      {isLoading == true ? (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      ) : (
        <></>
      )}
      <Grid container style={{ height: "100vh" }}>
        <Grid className="bg-color" item md={6} xs={12}>
          <img src="./images/moneytrek-login-image.png" className="login-page-mobile" />
        </Grid>
        <Grid item xs={12} md={6} className="loginRight">
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignitems: "center",
              }}
            >
            <Link to="/">
              <img className="top-logos" src="./images/logo.png" />
            </Link>

              <Grid className="loginHead">
                <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                  {/* Sign in */}
                </Typography>
              </Grid>
              {defaultView && <>
                <button className="email-login-register-btn bg-dark shadow text-white" onClick={() => emailRegister()}>Register </button>
                <br/>
                <button className="email-login-register-btn shadow bg-grey" onClick={() => emailLogin()}>Log in </button>
                <br/>
                <button className="google-login-btn shadow text-white bg-red" onClick={() => login()}>Continue with Google </button>
              </>}
              {showEmailRegister && <>
                <Grid>
                  <form style={{margin:'0px 10px'}}>
                  <Typography variant="h2" component="h3" className="form-heading" style={{fontWeight:'500', padding:'10px 0px', textAlign:'center',fontSize:'24px'}}>Create a new account</Typography>
                  <TextField
                          value={inputField.full_name}
                          onChange={inputsHandler}
                          style={{ marginBottom: "10px", width: "100%" }}
                          type="text"
                          label="Full Name"
                          variant="outlined"
                          name="full_name"
                          maxLength={25}
                      />
                      <TextField
                          value={inputField.email}
                          onChange={inputsHandler}
                          style={{ marginBottom: "10px", width: "100%" }}
                          type="email"
                          label="Email"
                          variant="outlined"
                          name="email"
                          maxLength={100}
                      />
                        <TextField
                          value={inputField.password}
                          onChange={inputsHandler}
                          style={{ marginBottom: "10px", width: "100%" }}
                          type="password"
                          label="Password"
                          variant="outlined"
                          name="password"
                          maxLength={50}
                      />
                      <button type="button" className="email-login-register-btn bg-dark text-white" onClick={handleRegisterSubmit}>Register</button>
                  </form>
                        
                    </Grid>
                {/* <button  onClick={() => emailRegister()}>Register with Email </button> */}
                <br/>
                <Box>
                  <button type="button" className="btn-small shadow bg-grey" onClick={() => showDefaultView()}>Back </button>
                  <button type="button" className="btn-small text-right shadow" onClick={() => emailLogin()}>Log in</button>
                </Box>
                <br/>
              </>}
              {showEmailLogin && <>
                <form style={{margin:'0px 10px'}}>
                      {/* <Box style={{}}>Login</Box> */}
                      <Typography variant="h2" component="h3" className="form-heading" style={{fontWeight:'500', padding:'10px 0px', textAlign:'center',fontSize:'24px'}}>Log in to MoneyTrek</Typography>
                      <TextField
                          value={inputField.email}
                          onChange={inputsHandler}
                          style={{ marginBottom: "10px", width: "100%" }}
                          type="email"
                          label="Email"
                          variant="outlined"
                          name="email"
                          maxLength={100}
                      />
                        <TextField
                          value={inputField.password}
                          onChange={inputsHandler}
                          style={{ marginBottom: "10px", width: "100%" }}
                          type="password"
                          label="Password"
                          variant="outlined"
                          name="password"
                          maxLength={50}
                      />
                      <button type="button" className="email-login-register-btn bg-dark shadow" onClick={() => handleLoginSubmit()}>Log in</button>
                  </form>
                <br/>
                <Box>
                  <button className="btn-small shadow" onClick={() => showDefaultView()}>Back </button>
                  <button className="btn-small text-right w-150 shadow" onClick={() => forgotPassword()}>Forgot Password? </button>
                </Box>
                <br/>
              </>}

              {showForgotPassword && <>
                <form style={{margin:'0px 10px'}}>
                      {/* <Box style={{}}>Login</Box> */}
                      <Typography variant="h2" component="h3" className="form-heading" style={{fontWeight:'400', padding:'10px 0px', textAlign:'center',fontSize:'24px'}}>Reset Password</Typography>
                      <TextField
                          value={inputField.email}
                          onChange={inputsHandler}
                          style={{ marginBottom: "10px", width: "100%" }}
                          type="email"
                          label="Email"
                          variant="outlined"
                          name="email"
                          maxLength={100}
                      />
                      <button type="button" className="email-login-register-btn bg-dark shadow" onClick={() => handleForgotPassword()}>Submit</button>
                  </form>
                
                <br/>
                <Box>
                  <button className="btn-small shadow" onClick={() => showDefaultView()}>Back </button>
                  <button className="btn-small text-right shadow" onClick={() => emailLogin()}>Log in </button>
                </Box>
                <br/>
              </>}

            </Box>
            <Box style={{fontSize:'13px', marginTop:"10px"}}>
              By registering, you agree to the<Link to="/terms-conditions"> Terms of Service(Cookie Use)</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.
            </Box>

            <Copyright sx={{ mt: 0, mb: 0 }} />
          </Container>
        </Grid>
      </Grid>
      {/*  */}
    </ThemeProvider>
  );
}
